import Phaser from 'phaser';

export default class MapGrid {
  /**
   * 
   * @param {*[][]} mapDataArray 
   */
  constructor(mapDataArray) {
    this.blockTypes = ['empty','land','landmark','vertical obstacle','horizontal obstacle', 'diagonal obstacle'];

    /** @type {{id:string, rowIndex: number, columnIndex: number, isEnd: boolean, isStart: boolean, filled: boolean, blockType: string, sprite: Phaser.GameObjects.Image}[][]} */
    this.blocks = [];

    // process map data
    for (let i = 0; i < mapDataArray.length; i++) {
      const mapRow = mapDataArray[i];

      /** @type {{id:string, rowIndex: number, columnIndex: number, isEnd: boolean, isStart: boolean, filled: boolean, blockType: string}[]} */
      const gridRow = [];
      for (let j = 0; j < mapRow.length; j++) {
        const block = { id: `${i}_${j}`, rowIndex: i, columnIndex: j, isEnd: false, isStart: false, filled: false, blockType: '' };
        const type = mapRow[j] === 'e' || mapRow[j] === 's' ? 'empty' : this.blockTypes[mapRow[j]];
        block.blockType = type;
        if (mapRow[j] === 'e') {
          block.isEnd = true;
        }
        if (mapRow[j] === 's') block.isStart = true;
        gridRow.push(block);
      }

      this.blocks.push(gridRow);
    }
  }

  getAreaBlock (startBlock) {
    const startRow = this.checkRow(startBlock);
    const areaCoordinates = [startRow];

    // check rows above
    let i = startBlock.rowIndex;

    while (i > 0) {
      const boxAbove = this.blocks[i - 1][startBlock.columnIndex];
      if (boxAbove.blockType === startBlock.blockType) {
        const rowAbove = this.checkRow(boxAbove);
        areaCoordinates.unshift(rowAbove);
      }
      else {
        break;
      }
      i--;
    }

    i = startBlock.rowIndex;
    while (i < this.blocks.length) {
      const boxBelow = this.blocks[i + 1][startBlock.columnIndex];

      if (boxBelow.blockType === startBlock.blockType) {
        const rowBelow = this.checkRow(boxBelow);
        areaCoordinates.push(rowBelow);
      }
      else {
        break;
      }
      i++;
    }

    return areaCoordinates;
  }

  checkRow (startBlock) {
    const rowGroup = [startBlock];
    let i = startBlock.columnIndex - 1;
    let checkBlock;
    while (i >= 0) {
      checkBlock = this.blocks[startBlock.rowIndex][i];

      if (checkBlock.blockType === startBlock.blockType && !checkBlock.filled) {
        rowGroup.unshift(checkBlock);
      }
      else {
        break;
      }
      i--;
    }

    i = startBlock.columnIndex + 1;
    while (i < this.blocks[startBlock.rowIndex].length) {
      checkBlock = this.blocks[startBlock.rowIndex][i];
      if (checkBlock.blockType === startBlock.blockType && !checkBlock.filled) {
        rowGroup.push(checkBlock);
      }
      else {
        break;
      }
      i++;
    }

    return rowGroup;
  }

  checkColumn (startBlock) {
    const columnGroup = [startBlock];
    let i = startBlock.rowIndex - 1;
    let checkBlock;
    while (i >= 0) {
      checkBlock = this.blocks[i][startBlock.columnIndex];
      if (checkBlock.blockType === startBlock.blockType && !checkBlock.filled) {
        columnGroup.unshift(checkBlock);
      }
      else {
        break;
      }
      i--;
    }

    i = startBlock.rowIndex + 1;
    while (i < this.blocks[startBlock.rowIndex].length) {
      checkBlock = this.blocks[i][startBlock.columnIndex];
      if (checkBlock.blockType === startBlock.blockType && !checkBlock.filled) {
        columnGroup.push(checkBlock);
      }
      else {
        break;
      }
      i++;
    }

    return columnGroup;
  }

  fillMapSpace (coordinateList,sprite) {
    for (let i = 0; i < coordinateList.length; i++) {
      const co = coordinateList[i];
      if (co.length > 0) {
        for (let j = 0; j < co.length; j++) {
          const b = co[j];
          this.blocks[b.rowIndex][b.columnIndex].filled = true;
          this.blocks[b.rowIndex][b.columnIndex].sprite = sprite;
        }
      }
      else {
        this.blocks[co.rowIndex][co.columnIndex].filled = true;
        this.blocks[co.rowIndex][co.columnIndex].sprite = sprite;
      }
    }
  }

  getBlockByCoordinates (row,column) {
    return this.blocks[row][column];
  }
}